import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import product_img from '../../../Assets/images/home/shopbystyle_3.jpg'
import earring_img from '../../../Assets/images/earring.jpg'
import { Link } from 'react-router-dom';
import wedding from '../../../Assets/images/WishList_Final-03.jpg'
import engagement from '../../../Assets/images/WishList_Final-02.jpg'
import stud from '../../../Assets/images/WishList_Final-01.jpg'
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { ErrorImg, base_url, logout, postHeader } from "../../../Helper/request";
import axios from 'axios';
import { showwishlist, wishlistdata, wishlistlength } from '../../../Reducer/wishlistReducer';
import { cartlength } from '../../../Reducer/cartReducer';
import { productcount } from '../../../Reducer/productReducer';
import CustomInquery from '../../product/CustomInquery';
import { toast } from 'react-toastify';
const Wishlist = ({ popup }) => {
    const [productData, setProductData] = useState({
        productId: "",
        productURL: ""
    })
    const [bookAppointmentShow, setbookAppointmentShow] = useState(false);
    const bookAppointment_handleShow = (productInfo) => {
        const domainWithHttps = `${window.location.protocol}//${window.location.host}`;
        setProductData({
            productId: productInfo?.product_id,
            productURL: `${domainWithHttps}/custom-product-detail/${productInfo?.group_id}/${productInfo?.slug
                }${productInfo?.stone_quality &&
                    productInfo?.stone_quality !== ""
                    ? "/" +
                    encodeURI(productInfo?.stone_quality).replaceAll(
                        "+/",
                        "%2B%2F"
                    )
                    : "/"
                }`
        })
        setbookAppointmentShow(true);

    }
    const bookAppointment_handleClose = () => setbookAppointmentShow(false);

    const dispatch = useDispatch();
    const userdata = useSelector(state => state.persistedReducer.home.user)
    const session_id = useSelector(state => state.persistedReducer.home.session_id)
    const wishlist = useSelector(state => state.persistedReducer.wish.wishlistdata)

    const islogin = useSelector(state => state.persistedReducer.home.isLogin)
    useEffect(() => {
        if (window.location.pathname == "/wishlist") {
            dispatch(showwishlist(false));
        }
        wishlistapi();
        return () => {
            popup = true;
        }
    }, [])
    const wishlistapi = () => {
        const data = {
            user_id: userdata?.user_id ? userdata?.user_id : "",
            session_id,
            token: userdata?.token ? userdata?.token : ""
        }
        axios.post(base_url + '/product/wish_list', data, {
            headers: postHeader
        })
            .then(response => {
                if (response.data.status == 1) {
                    dispatch(wishlistdata(response.data.data))
                } else {
                    console.log(response.data.message)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    //******Klaviyo events Remove From Wishlist....****** Start
    function kleviyoRemoveWishlist(val) {
        var item = {
            ProductID: val?.product_id,
            ProductName: val?.name,
            price: val.price,
            Image_Url: val?.url
        };
        if (window?.klaviyo) {
            window.klaviyo.push(["track", "Remove From Wishlist", item]);
        }
    }
    // ******Klaviyo events Remove From Wishlist..********* End
    const remove_from_wishlist = async (group_id, product_id, index, val) => {
        kleviyoRemoveWishlist(val)
        const data = {
            user_id: userdata?.user_id ? userdata?.user_id : "",
            session_id,
            product_id,
            group_id,
            token: userdata?.token ? userdata?.token : "",
        };
        await axios
            .post(base_url + "/product/add_to_wishlist", data, {
                headers: postHeader,
            })
            .then((res) => {
                if (res.data.status == 1) {
                    dispatch(wishlistlength(res.data.data.count));
                    const product = wishlist?.filter(val => val.product_id != product_id);
                    dispatch(wishlistdata(product))
                } else if (res.data.status == 2) {
                    logout();
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    // klaviyo add to cart event start
    function klavito_addToCart(val) {
        const item = {
            ProductID: val?.product_id,
            ProductName: val?.name,
            price: val?.price,
            SKU: val?.sku,
            Image_Url: val?.url
        }
        if (window?.klaviyo) {
            window.klaviyo.push(["track", "Added to Cart", item]);
        }
    }
    // klaviyo add to cart event End
    const add_to_cart = async (e, product_id, group_id, val) => {
        e.preventDefault();
        klavito_addToCart(val)
        const data = {
            user_id: userdata?.user_id ? userdata?.user_id : "",
            token: userdata?.token ? userdata?.token : "",
            session_id,
            product_id,
            quantity: 1,
            ring_size: "",
            engraving_text: "",
            engraving_font: "great_vibes",
            is_engraving: 0,
            stone_quality: val?.stone_quality ? val?.stone_quality : "",
        };
        await axios
            .post(base_url + "/order/add_to_cart", data, {
                headers: postHeader,
            })
            .then((res) => {
                if (res.data.status == 1) {
                    toast.success(res?.data.message)
                    dispatch(cartlength(res.data.data.total_count));
                    // remove_from_wishlist(group_id,product_id);
                } else if (res.data.status == 2) {
                    logout();
                } else {
                    dispatch(productcount(0));
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const stoneQualtiyHandle = (val) => {
        if (val && val !== "") {
            return "?stone_quality=" + val.replaceAll("+/", "%2B%2F")
        } else {
            return "/"
        }
    }
    return (
        <>

            {popup == false || popup == undefined ?
                <section className='cart-page Wishlist-page'>
                    <Container>



                        <Row className='mt-lg-4'>
                            <Col md={{ span: 7, offset: 1 }} lg={{ span: 8, offset: 1 }}>
                                <div className='shopping-cart-product-box'>
                                    <h1 className='title'> Wish List</h1>
                                    {
                                        !islogin && <h2><Link to='/login'>Sign in</Link> to Your Account. <Link to='/login'>Create an Account.</Link></h2>
                                    }

                                    {
                                        wishlist.length > 0 ? <div className='added_products_list'>
                                            {wishlist && wishlist?.map((val, index) =>
                                                <div className='wishlist-product-box product_text_box'>
                                                    <div className='single-product-box'>
                                                        <Link to={`${val?.is_custom_product == "1" ? "/custom-product-detail/" : "/product-detail/"}${val?.group_id}/${val?.slug}${val?.stone_quality && val?.stone_quality !== ""
                                                            ? "/" +
                                                            encodeURI(val?.stone_quality).replaceAll(
                                                                "+/",
                                                                "%2B%2F"
                                                            )
                                                            : "/"
                                                            }`}><img id={"img-" + index} onError={() => ErrorImg("img-" + index)} src={val.url} alt={val.name} className='product-img' /></Link>
                                                        <div className='product-detail'>
                                                            <div className='buy-product'>
                                                                <h3 className='product-name'><Link to={`${val?.is_custom_product == "1" ? "/custom-product-detail/" : "/product-detail/"}${val?.group_id}/${val?.slug}${val?.stone_quality && val?.stone_quality !== ""
                                                                    ? "/" +
                                                                    encodeURI(val?.stone_quality).replaceAll(
                                                                        "+/",
                                                                        "%2B%2F"
                                                                    )
                                                                    : "/"
                                                                    }`}> {val.name}</Link>
                                                                </h3>
                                                                <h5 className='product-SKU'>{val.sku}</h5>
                                                                {/* <div className='ringsize-select'>
                                                        <select className='shopping-cart_select'>
                                                            <option>6.5</option>
                                                            <option>6.5</option>
                                                            <option>6.5</option>
                                                        </select>
                                                        <span className="filter-dropdown-arrow"></span>
                                                    </div> */}
                                                                <h4 className='product-price'>${val.price}</h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        val?.is_custom_product == "1" ? <button
                                                            type="button"
                                                            className="theme_btn mt-3 btn btn-primary"
                                                            onClick={() => bookAppointment_handleShow(val)}
                                                        >
                                                            Inquire Now
                                                        </button> : <Button className='theme_btn mt-3' onClick={(e) => add_to_cart(e, val.product_id, val.group_id, val)}>Add to Cart</Button>
                                                    }

                                                </div>
                                            )}
                                        </div> : <section className='my-5'>

                                            <Row>
                                                <Col md={12} lg={8} xl={8} sm={12}>
                                                    <div className='underWrapper shadow text-center p-5 mb-5'>
                                                        <h3 className='fontLora colorPrimary'>Your Wishlist is empty</h3>
                                                        <p className='greenText'>You have not added anything to your wishlist</p>
                                                        <div className='mt-5'>
                                                            <Link className='theme_btn_light text-center' to="/productlist/engagement-rings">Continue Shopping</Link>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>

                                        </section>
                                    }

                                </div>
                            </Col>

                        </Row>
                        <Row>
                            <Col lg={10} md={10} className='m-auto'>
                                <div className='continue-shoping'>
                                    <h1 className='title'> Continue shopping</h1>
                                    <Row className='continue-shoping-inner'>
                                        <Col lg={4} md={4}>
                                            <div className='continue-shoping-box'>
                                                <img src={wedding} alt='Wedding Bands' className='img-fluid' />
                                                <Link to="/productlist/wedding-bands" className='theme_btn mt-3'>Wedding Bands</Link>
                                            </div>
                                        </Col>

                                        <Col lg={4} md={4}>
                                            <div className='continue-shoping-box'>
                                                <img src={engagement} alt='Engagement Rings' className='img-fluid' />
                                                <Link to="/productlist/engagement-rings" className='theme_btn mt-3'>Engagement Rings</Link>
                                            </div>
                                        </Col>
                                        <Col lg={4} md={4}>
                                            <div className='continue-shoping-box'>
                                                <img src={stud} alt='Diamond Studs' className='img-fluid' />
                                                <Link to="/productlist/fine-jewelry" className='theme_btn mt-3'>Diamond Studs</Link>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                :
                <div className='shopping-checkout-order-summury'>
                    <div className='shopping-cart-product-box'>
                        <div className='added_products_list p-0'>
                            {wishlist && wishlist?.map((val, index) =>
                                <div className='single-product-box'>
                                    {/* remove product */}
                                    <span className='remove-product' onClick={() => remove_from_wishlist(val?.group_id, val?.product_id, index, val)}>x</span>
                                    <Link to={`${val?.is_custom_product == "1" ? "/custom-product-detail/" : "/product-detail/"}${val?.group_id}/${val?.slug
                                        }${val?.stone_quality &&
                                            val?.stone_quality !== ""
                                            ? "/" +
                                            encodeURI(val?.stone_quality).replaceAll(
                                                "+/",
                                                "%2B%2F"
                                            )
                                            : "/"
                                        }`}><img id={"img-" + index} onError={() => ErrorImg("img-" + index)} src={val.url} alt={val.name} className='product-img' /></Link>
                                    <div className='product-detail'>
                                        <div className='buy-product'>
                                            <h3 className='product-name'><Link to={`${val?.is_custom_product == "1" ? "/custom-product-detail/" : "/product-detail/"}${val?.group_id}/${val?.slug
                                                }${val?.stone_quality &&
                                                    val?.stone_quality !== ""
                                                    ? "/" +
                                                    encodeURI(val?.stone_quality).replaceAll(
                                                        "+/",
                                                        "%2B%2F"
                                                    )
                                                    : "/"
                                                }`}>{val.name}</Link></h3>
                                            <h4 className='product-price'>${val.price}</h4>
                                            {
                                                val?.is_custom_product == "1" ? "" : <Button className='theme_btn' onClick={(e) => add_to_cart(e, val.product_id, val.group_id, val)}>Add to Cart</Button>
                                            }

                                        </div>
                                    </div>
                                </div>)}

                            <div className='shopping-cart-order-summury'>
                                <Link to="/wishlist" className='theme_btn'>Wish List</Link>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <Modal
                show={bookAppointmentShow}
                onHide={bookAppointment_handleClose}
                className="BookAppointment_modal"
                size="lg"
                centered
                backdropClassName="green-backdrop"
                backdrop="static" // Prevents closing on outside click
                keyboard={false}
                style={{ zIndex: '999999999' }}
            >
                <span onClick={bookAppointment_handleClose} className="sent-hint-close">
                    x
                </span>
                <Modal.Body>
                    <div className="send_hint_head text-center">
                        <h3>CUSTOM INQUIRY</h3>
                        <p>Let us know exactly what you want.</p>
                    </div>
                    <CustomInquery
                        bookAppointment_handleClose={bookAppointment_handleClose}
                        type="product"
                        product_id={productData?.productId}
                        productLink={productData?.productURL}

                    />
                </Modal.Body>
            </Modal>
        </>
    )
}


export default Wishlist